import AddCircleIcon from "@mui/icons-material/AddCircle";
import React from "react";
import { ListStateIcon } from "../ListStateIcon/ListStateIcon";

interface ListStateIconAddProps {
    color?: string;
    noMargin?: boolean;
    tooltip?: string;
  }
  
export const ListStateIconAdd = ({
    noMargin,
    tooltip,
    color,
}: ListStateIconAddProps) => (
    <ListStateIcon
        color={color}
        noMargin={noMargin}
        tooltip={tooltip}
        icon={AddCircleIcon}
    />
);
